// Module
var code = `<div class="heatmap-filter">
    <div class="heatmap-filter-items-list">
        {{#each intervals: i}}
            <div class="heatmap-filter-item{{#if !intervals[i].IsSelected}} _unselected{{/if}}" style="background-color: {{intervals[i].LeftColor}}; color: {{foregroundColor}}" on-click="['intervalClicked', intervals[i]]">{{intervals[i].text}}</div>
        {{/each}}
    </div>
    <terceraComboBox name="scaleMultiplierCombobox" showLastValue="true" items="{{scaleMultiplierItems}}" selectedItem="{{scaleMultiplierSelectedItem}}" on-ValueChange="scaleMultiplierSelectedItemChanged"/>
</div>`;
// Exports
export default code;